// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MjS6Z","footerLogo":"Footer_footerLogo__itacB","footerNav":"Footer_footerNav__Gdle-","footerBottom":"Footer_footerBottom__TFjKG"};